import type { AddressPlaceDetails } from "./AddressQuestion";

/**
 * The parts a resolved address has to carry before the flow accepts it.
 *
 * A provider is dispatched to a doorstep, so "Groenstraat, Gent" — a street
 * with no number — is not an address the request can be fulfilled at, even
 * though Google is perfectly happy to return it.
 */
export const REQUIRED_ADDRESS_PARTS = [
  "streetNumber",
  "street",
  "postalCode",
  "city",
] as const;

export type IAddressPart = (typeof REQUIRED_ADDRESS_PARTS)[number];

/**
 * Which of the required parts the place is missing — `[]` for a complete one.
 *
 * Anything the user typed by hand counts as missing everything: only a
 * suggestion picked from the list ever comes back with components attached.
 */
export const missingAddressParts = (
  place: AddressPlaceDetails | null | undefined
): IAddressPart[] =>
  REQUIRED_ADDRESS_PARTS.filter((part) => !String(place?.[part] ?? "").trim());
